export function parseRouteParamToBoolean(
  value: string | null | undefined,
): boolean | null {
  try {
    if (typeof value === 'string') {
      const valueLowerCase = value.toLowerCase();

      if (valueLowerCase === 'true') {
        return true;
      }

      if (valueLowerCase === 'false') {
        return false;
      }
    }
  } catch {
    // ignore
  }

  return null;
}
